/** Path segment for public volunteer check-in (no login). */
export const STATIC_MODE_SEGMENT = 'static-mode'

/**
 * /{branchId}/static-mode/event-management/{eventId}/registration?volunteerToken=…
 */
export function isStaticModePath(pathname = window.location.pathname): boolean {
  return pathname.split('/').includes(STATIC_MODE_SEGMENT)
}

export function isStaticModeRegistrationPath(
  pathname = window.location.pathname
): boolean {
  return (
    isStaticModePath(pathname) &&
    /\/event-management\/[^/]+\/registration\/?$/.test(pathname)
  )
}

export function getBranchIdFromPathname(
  pathname = window.location.pathname
): string {
  return pathname.split('/').filter(Boolean)[0] ?? ''
}

export function buildStaticModeRegistrationPath(
  branchId: string,
  eventId: string
): string {
  return `/${branchId}/${STATIC_MODE_SEGMENT}/event-management/${eventId}/registration`
}

export function buildStaticModeNotFoundPath(
  pathname = window.location.pathname
): string {
  const segments = pathname.split('/').filter(Boolean)
  const staticModeIndex = segments.indexOf(STATIC_MODE_SEGMENT)
  const prefix =
    staticModeIndex > 0 ? `/${segments.slice(0, staticModeIndex).join('/')}` : ''

  return `${prefix}/${STATIC_MODE_SEGMENT}/404`
}
